import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png';



// Utility to chunk array
function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}




// Header Component
const Header = () => (
  <>
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1px",
      }}
    >
      <Image src={sitlogo} style={{ width: "68px", height: '30px' }} />
    </View>
    <View style={{ width: '100%', height: '4.6%', border: '1.5px solid black', justifyContent: "center", alignItems: "center" }}>
      <Text style={{
        fontSize: 10, fontFamily: 'Poppins',
        fontWeight: 600,
      }}>
        BATCH RECORD
      </Text>
    </View>
    <View style={{ width: '100%', height: '4.6%', border: '1.5px solid black', borderTop: "none", flexDirection: "row", paddingLeft: 500, alignItems: "center" }}>
      <Text style={{
        fontSize: 8.5, fontFamily: 'Poppins',
        fontWeight: 600,
      }}>
        Year :
      </Text>
      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', paddingLeft: 40 }}>
        2025 - 2026
      </Text>
    </View>
  </>
);

const BatchRecordReport = ({ data }) => {




  Font.register({
    family: 'Poppins',
    fonts: [
      {
        src: '/fonts/Poppins-Regular.ttf',
        fontWeight: 'normal',
      },
      {
        src: '/fonts/Poppins-SemiBold.ttf',
        fontWeight: 600,
      },
      {
        src: '/fonts/Poppins-Bold.ttf',
        fontWeight: 'bold',
      },
    ],
  });


  return (
    <Document>
      {data.map((chunk, chunkIdx) => (
        <Page key={chunkIdx} size="A4" orientation="landscape" style={{ padding: 30, fontSize: 10 }}>

          <Header />
          {/* this is main section */}

          <View style={{ width: '100%', height: '84%', flexDirection: "column" }}>
            {/* this is the 2nd main section */}


            <View style={{ width: '100%', height: '5.6%', border: '1.5px solid black', borderTop: "none", flexDirection: "row", alignItems: "center", }}>
              <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, paddingLeft: 10 }}>Training Programme : </Text>
              <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', paddingLeft: 25 }}>Piping Engineering </Text>
            </View>

            <View style={{ width: '100%', height: '9%', border: '1.5px solid black', borderTop: "none", flexDirection: "row", alignItems: "center", }}>

              <View style={{ width: '4%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Batch
                </Text>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  No.
                </Text>
              </View>
              <View style={{ width: '10%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Training
                </Text>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Co-Ordinator
                </Text>
              </View>
              <View style={{ width: '10%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Particulars
                </Text>
              </View>

              <View style={{ width: '7%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Start
                </Text>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Date
                </Text>
              </View>
              <View style={{ width: '7%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Finish
                </Text>
                <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Date
                </Text>
              </View>
              <View style={{ width: '6%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  No. Of
                </Text>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Student
                </Text>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Enrolled
                </Text>
              </View>
              <View style={{ width: '6%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Tranfer
                </Text>

              </View>
              <View style={{ width: '6%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Cancel
                </Text>

              </View>
              <View style={{ width: '4%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Left
                </Text>

              </View>

              <View style={{ width: '12%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Tl. No of students
                </Text>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  appeared
                </Text>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  final exam
                </Text>
              </View>

              <View style={{ width: '5.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  No of
                </Text>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  students
                </Text>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins', fontWeight: '600' }}>
                  passed
                </Text>
              </View>

              <View style={{ width: '7.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  No of students
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  passed thru
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  reexam
                </Text>
              </View>

              <View style={{ width: '5.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Tl. No of
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  students
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  passed
                </Text>
              </View>

              <View style={{ width: '5.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  No of
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  students
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  interview
                </Text>
              </View>

              <View style={{ width: '5.5%', height: '100%', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  No of
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  students
                </Text>
                <Text style={{ fontSize: 7, fontFamily: 'Poppins', fontWeight: '600' }}>
                  Placed
                </Text>
              </View>

            </View>

            {chunk.batches?.map((row, idx) => (
              <View key={idx} style={{ width: '100%', height: '6%', border: '1.5px solid black', borderTop: "none", flexDirection: "row", alignItems: "center", }}>

                <View style={{ width: '4%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "flex-start", paddingLeft: 1 }}>
                  <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', }}>
                    {row.Batch_code}
                  </Text>

                </View>
                <View style={{ width: '10%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "flex-start", paddingLeft: 1 }}>
                  <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', }}>
                    {row.Training_Coordinator}
                  </Text>

                </View>
                <View style={{ width: '10%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "flex-start", paddingLeft: 1 }}>
                  <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', }}>
                    {row.Category}
                  </Text>
                </View>

                <View style={{ width: '7%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 7.5, fontFamily: 'Poppins', }}>
                    {row.SDate}
                  </Text>

                </View>
                <View style={{ width: '7%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 7.5, fontFamily: 'Poppins', }}>
                    {row.EDate}
                  </Text>

                </View>
                <View style={{ width: '6%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>
                    {row.Admission_Count}
                  </Text>

                </View>
                <View style={{ width: '6%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>
                    {row.Transfer_Count}
                  </Text>

                </View>
                <View style={{ width: '6%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>
                  {row.Cancellation_Count}
                  </Text>

                </View>
                <View style={{ width: '4%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>
                    0
                  </Text>

                </View>

                <View style={{ width: '12%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>
                            {row.exam_count}
                  </Text>

                </View>

                <View style={{ width: '5.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>
          
                  </Text>

                </View>

                <View style={{ width: '7.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>

                  </Text>

                </View>

                <View style={{ width: '5.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>

                  </Text>

                </View>

                <View style={{ width: '5.5%', height: '100%', borderRight: '1.5px solid black', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>

                  </Text>

                </View>

                <View style={{ width: '5.5%', height: '100%', justifyContent: "center", alignItems: "center", flexDirection: 'column' }}>
                  <Text style={{ fontSize: 8, fontFamily: 'Poppins', }}>

                  </Text>
                </View>
              </View>
            ))}
          </View>



        </Page>
      ))}
    </Document>
  )
}

export default BatchRecordReport